import { useEffect, useState } from "react";
import ModalWindow from "../../../../../../../Components/ModalWindow/ModalWindow.js";
import ServerRequests from "../../../../../../../Services/Api/ServersRequests.ts";
import AddServerPanel from "../AddServerPanel/AddServerPanel.js";
import GroupServersRequests from "../../../../../../../Services/Api/GroupServersRequests.ts";
import { AddToastNotification } from "../../../../../../../Services/ToastNotification/ToastNotificationManager.js";

const AddServerModal = ({groupId, groupServers, refresh, hide}) => {
    const groupServersId = groupServers.map(x => x.serverId)

    const serverRequests = new ServerRequests();
    const groupServersRequests = new GroupServersRequests();

    const [servers, setServers] = useState([]);
    const [selectedServers, setSelectedServers] = useState([]);

    const ChangeSelection = (id) => {
        let selected = selectedServers;

        let existing = selectedServers.find(x => x == id);

        if(existing) {
            selected.splice(selectedServers.indexOf(existing), 1);
        }else{
            selected.push(id);
        }

        setSelectedServers(selected);
    }

    const AddServers = () => {
        if(selectedServers.length > 0){
            const data = {
                groupId: groupId,
                ServerIds: selectedServers
            }
            
            groupServersRequests.Add(data, () => { refresh(); hide(); });
        }else {
            AddToastNotification("Musisz wybrać przynajmniej jeden serwer!", 0)
        }
    }

    useEffect(() => {
        serverRequests.GetAll(setServers);
    }, []);

    if(!servers)
        return (<></>)

    const serversToShow = servers.filter(x => !groupServersId.includes(x.id));

    return (
        <ModalWindow 
            title={"Dodaj serwer do grupy"}
            minWidth={"60%"}
            content={
                <div>
                    { serversToShow.length == 0 &&
                        <p>Nie ma serwerów do dodania!</p>                  
                    }
                    { 
                        serversToShow.map((server) =>                     
                            <AddServerPanel server={server} ChangeSelection={ChangeSelection}/>
                        )
                    }
                </div>
            }
            buttons={[
                { Text: "Dodaj", onClick: () => { AddServers() }},
                { Text: "Anuluj",  onClick: () => { hide() }, className: "modalSecondaryBtn" }
            ]}
        />
    )
}

export default AddServerModal;